import {Button, IconButton} from "@mui/material";
import {useEffect} from "react";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {clientColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";
import LoadingContent from "../components/ui/LoadingContent";

const Clients = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest({baseUrl: "/clients", resource: "clients"});

  // Hook para el diálogo de confirmación
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async (id) => {
    try {
      await remove(id);
      await list();
    } catch (error) {
      console.error("Error al eliminar el cliente:", error);
    }
  });

  useEffect(() => {
    (async () => {
      try {
        await list();
      } catch (error) {
        console.error("Error al cargar los clientes:", error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowClick = (client) => {
    if (!client?.client_id) {
      console.error("Error: No se encuentra al cliente");
      return;
    }
    navigate(`/client-form`, {state: {id: client?.client_id}});
  };

  const handleOpenDeleteDialog = (id) => {
    const found = Array.isArray(data) ? data.find((client) => client.client_id === id) : null;
    openDialog(id, found?.name || "");
  };

  const columns = [
    ...clientColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="delete"
          color="error"
          onClick={(e) => {
            e.stopPropagation();
            handleOpenDeleteDialog(params.row.client_id);
          }}
        >
          <FiTrash2 />
        </IconButton>
      )
    }
  ];

  return (
    <>
      <Window
        title={"Clientes"}
        topRightButtons={
          <Button
            variant="contained"
            color="primary"
            startIcon={<FiPlus />}
            onClick={() => {
              navigate(`/client-form`);
            }}
          >
            Nuevo cliente
          </Button>
        }
      >
        {loading ? (
          <LoadingContent />
        ) : (
          <ListView columns={columns} data={data} getRowId={(row) => row.client_id} onRowClick={handleRowClick} />
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="cliente"
        entityLabel={itemName}
      />
    </>
  );
};

export default Clients;
